import { Grid, GridItem } from "@chakra-ui/react";
import useSidebar from "../../hooks/useSidebar";

type LayoutProps = {
    header: React.ReactNode;
    nav: React.ReactNode;
    main: React.ReactNode;
    footer: React.ReactNode;
}

const Layout = ({ header, nav, main, footer }: LayoutProps) => {
    const { sidebarOpen } = useSidebar();

    return (
        <Grid
            templateAreas={`"header header"
                            "nav main"
                            "footer footer"`}
            gridTemplateRows="64px auto 64px" // ← 高さは内容に応じて変動
            gridTemplateColumns={{
                base: "0px 100vw",
                lg: "0px 100vw", // nav は非表示のまま
            }}
            minH="100vh" // ← 足りない高さは下に伸ばす
            sx={{
                "&::-webkit-scrollbar": { display: "none" },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
            }}
        >
            <GridItem
                area="header"
                as="header"
                boxSizing="border-box"
                p={4}
                bg="#0E0F0E"
                position="sticky"
                top={0}
                zIndex={10}
                gridColumn="1 / span 2"
            >
                {header}
            </GridItem>

            <GridItem
                area="nav"
                display="none"
            >
                {/* {nav} は Drawer 側で表示 */}
            </GridItem>

            <GridItem
                area="main"
                as="main"
                p={4}
            >
                {main}
            </GridItem>

            <GridItem
                area="footer"
                as="footer"
                p={4}
                bg="#0E0F0E"
                color="white"
                fontSize={{ base: "xs", sm: "sm" }}
                gridColumn="1 / span 2"
            >
                {footer}
            </GridItem>
        </Grid>
    );
};

export default Layout;